/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-computed-property-dependencies, ember/require-tagless-components, getter-return */
// Extends From
import Component from '@ember/component';
// Ember Imports
import { computed } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
// External Imports
import { stripDiacritics } from 'ember-power-select/utils/group-utils';
// Internal Imports
import LearnerFlag from 'linced-app/enums/learner-flag';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import { toCamelCase } from '@linc-technologies/linced-common/utils/strings';

export default class LearnerFlags extends Component {
  @service
  session;

  @service
  options;

  @service
  strings;

  LearnerFlag = LearnerFlag;
  hideAccessInfoIcon = false;

  @computed('user.type')
  get isLearner() {
    return this.get('user.type') === PersonType.LEARNER;
  }

  @computed('user.displayEthnicity', 'isLearner')
  get ethnicFlag() {
    if (
      !this.options.schoolGet(
        this.session.school,
        'core:theme:showEthnicityFlag',
      ) ||
      !this.showEthnicFlag ||
      !this.isLearner
    ) {
      return;
    }
    let flag = toCamelCase(stripDiacritics(this.user.displayEthnicity));
    if (flag) {
      return `/assets/images/flags/${flag}.png`;
    }
  }

  @computed(
    'user.fields.{core:criticalInfo.value,core:medicalCondition.value,core:allergies.value,custom:medicalNotes.value}',
    'user.learner.currentMedicalConditions.[]',
  )
  get medicalFlag() {
    if (this.get('user.fields.core:criticalInfo.value')) {
      return true;
    }
    if (this.get('user.fields.core:medicalCondition.value')) {
      return true;
    }
    if (this.get('user.fields.core:allergies.value')) {
      return true;
    }
    if (this.get('user.fields.custom:medicalNotes.value')) {
      return true;
    }
    return !isEmpty(this.get('user.learner.currentMedicalConditions'));
  }

  @computed('user.fields.core:permissionAlert.value')
  get permissionsFlag() {
    return !!this.get('user.fields.core:permissionAlert.value');
  }

  @computed('user.fields.core:accessArrangements.value')
  get arrangementsFlag() {
    return !!this.get('user.fields.core:accessArrangements.value');
  }

  @computed('user.fields.nzMOE:type')
  get internationalFlag() {
    return this.get('user.fields.nzMOE:type.value') === 'FF';
  }
}
